module.exports = __webpack_public_path__ + "fa-regular-400.4f8bb28722068f7b6665.woff";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-regular-400.woff
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-regular-400.woff
// module chunks = styles